import React from 'react'

export default function Footer({ name, tagline }) {
  return (
    <footer>
      <p>© {new Date().getFullYear()} {name}</p>
      <p>{tagline}</p>
    </footer>
  );
}
